import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { IssueService } from './issue.service';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { BusinessPageComponent } from './components/business-page/business-page.component';
import { AndroidAppPageComponent } from './components/android-app-page/android-app-page.component';
import { DigitalMartPageComponent } from './components/digital-mart-page/digital-mart-page.component';
import { EcommercePageComponent } from './components/ecommerce-page/ecommerce-page.component';
import { FlutterPageComponent } from './components/flutter-page/flutter-page.component';
import { DjangoPageComponent } from './components/django-page/django-page.component';
import { IbeaconPageComponent } from './components/ibeacon-page/ibeacon-page.component';
import { ValuePageComponent } from './components/value-page/value-page.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { ExampleProjectComponent } from './components/example-project/example-project.component';
import { ExamProjectComponent } from './components/exam-project/exam-project.component';
import { ExaProjectComponent } from './components/exa-project/exa-project.component';
import { ExProjectComponent } from './components/ex-project/ex-project.component';
import { SampleComponent } from './components/sample/sample.component';
import { SampleProjectComponent } from './components/sample-project/sample-project.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { AboutusComponent } from './components/aboutus/aboutus.component';
import { BlogComponent } from './components/blog/blog.component';
import { CakePhpComponent } from './components/cake-php/cake-php.component';
import { CrossPlatformComponent } from './components/cross-platform/cross-platform.component';
import { OdooAppComponent } from './components/odoo-app/odoo-app.component';
import { PythonappComponent } from './components/pythonapp/pythonapp.component';
import { SwiftAppComponent } from './components/swift-app/swift-app.component';
import { TechnologyComponent } from './components/technology/technology.component';

import { WebPagesComponent } from './components/web-pages/web-pages.component';
import { IphoneComponent } from './components/iphone/iphone.component';
import { CareerComponent } from './components/career/career.component';
import { PhpComponent } from './components/php/php.component';
import { XamarinComponent } from './components/xamarin/xamarin.component';
import { MeanStackComponent } from './components/mean-stack/mean-stack.component';
import { OurTeamComponent } from './components/our-team/our-team.component';

import { ServicePageComponent } from './components/service-page/service-page.component';
import { MobileApplicationDevelopmentPageComponent } from './components/mobile-application-development-page/mobile-application-development-page.component';
import { ContactusComponent } from './components/contactus/contactus.component';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { LaravelApplicationDevelopmentComponent } from './components/laravel-application-development/laravel-application-development.component';
import { WebDesignAndDevelopmentComponent } from './components/web-design-and-development/web-design-and-development.component';
import { PhonegapAppDevelopmentComponent } from './components/phonegap-app-development/phonegap-app-development.component';
import { GraphicDesignComponent } from './components/graphic-design/graphic-design.component';
import { WearableAppDevelopmentComponent } from './components/wearable-app-development/wearable-app-development.component';
import { InteractiveTvAppDevelopmentComponent } from './components/interactive-tv-app-development/interactive-tv-app-development.component';
import { from } from 'rxjs';

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    BusinessPageComponent,
    AndroidAppPageComponent,
    DigitalMartPageComponent,
    EcommercePageComponent,
    FlutterPageComponent,
    DjangoPageComponent,
    IbeaconPageComponent,
    ValuePageComponent,
    PortfolioComponent,
    ExampleProjectComponent,
    ExamProjectComponent,
    ExaProjectComponent,
    ExProjectComponent,
    SampleComponent,
    SampleProjectComponent,
    HeaderComponent,
    FooterComponent,
    AboutusComponent,
    BlogComponent,
    CakePhpComponent,
    CrossPlatformComponent,
    OdooAppComponent,
    PythonappComponent,
    SwiftAppComponent,
    TechnologyComponent,

    WebPagesComponent,
    IphoneComponent,
    CareerComponent,
    PhpComponent,
    XamarinComponent,
    MeanStackComponent,
    OurTeamComponent,

    ServicePageComponent,
    MobileApplicationDevelopmentPageComponent,
    ContactusComponent,
    LaravelApplicationDevelopmentComponent,
    WebDesignAndDevelopmentComponent,
    PhonegapAppDevelopmentComponent,
    GraphicDesignComponent,
    WearableAppDevelopmentComponent,
    InteractiveTvAppDevelopmentComponent,
  ],
  imports: [
    BrowserModule,
    Ng2TelInputModule,
    AppRoutingModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    HttpClientModule,
    ReactiveFormsModule,
  ],
  providers: [IssueService],
  bootstrap: [AppComponent],
})
export class AppModule {}
